import { render, staticRenderFns } from "./BaseSort.vue?vue&type=template&id=06df4b6e&scoped=true&"
import script from "./BaseSort.vue?vue&type=script&lang=js&"
export * from "./BaseSort.vue?vue&type=script&lang=js&"
import style0 from "./BaseSort.vue?vue&type=style&index=0&id=06df4b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df4b6e",
  null
  
)

export default component.exports